import type { PhoneNumber } from "./phoneNumberService"

export function listInboundAgentIds(p: PhoneNumber): string[] {
  if (!p.inbound_agents?.length) {
    return []
  }
  return p.inbound_agents.map((a) => a.agent_id).filter(Boolean)
}

export function listOutboundAgentIds(p: PhoneNumber): string[] {
  if (!p.outbound_agents?.length) {
    return []
  }
  return p.outbound_agents.map((a) => a.agent_id).filter(Boolean)
}

export function primaryInboundAgentId(p: PhoneNumber): string | null {
  return listInboundAgentIds(p)[0] ?? null
}

export function primaryOutboundAgentId(p: PhoneNumber): string | null {
  return listOutboundAgentIds(p)[0] ?? null
}

export function hasInboundAgent(p: PhoneNumber): boolean {
  return listInboundAgentIds(p).length > 0
}

export function hasOutboundAgent(p: PhoneNumber): boolean {
  return listOutboundAgentIds(p).length > 0
}
